module.exports = __webpack_public_path__ + "img/juntos-somos-mais-fortes.svg";